
// Manages score, level, and game speed
import { GAME_CONFIG } from './gameConfig';

// Start the block drop timer
export function startDropTimer(scene) {
  // Clear any existing timer
  if (scene.dropTimer) {
    scene.dropTimer.destroy();
  }
  
  // Create a new timer to auto-drop blocks
  scene.dropTimer = scene.time.addEvent({
    delay: scene.dropSpeed,
    callback: () => {
      if (!scene.isGameActive || scene.isPaused) return;
      
      // Move block down
      if (!canMoveTo(scene.board, scene.currentBlock, 0, 1)) {
        // If it can't move down, lock it in place
        scene.lockCurrentBlock();
      } else {
        scene.currentBlock.y++;
        scene.drawBlock(scene, scene.currentBlock);
      }
    },
    callbackScope: scene,
    loop: true
  });
}

// Update the score display and value
export function updateScore(scene, points) {
  scene.score += points;
  scene.ui.scoreText.setText(`Score: ${scene.score}`);
}

// Increase the level and speed
export function levelUp(scene, newLevel) {
  scene.level = newLevel;
  scene.ui.levelText.setText(`Level: ${scene.level}`);
  
  // Increase speed (decrease delay) with each level
  scene.dropSpeed = Math.max(
    GAME_CONFIG.initialSpeed - (scene.level - 1) * GAME_CONFIG.speedIncrement,
    GAME_CONFIG.minSpeed
  );
  
  // Update the drop timer with the new speed
  if (scene.dropTimer) {
    scene.dropTimer.destroy();
    startDropTimer(scene);
  }
  
  // Add visual feedback for level up
  const levelUpText = scene.add.text(
    GAME_CONFIG.gameWidth / 2,
    GAME_CONFIG.gameHeight / 2,
    `LEVEL ${scene.level}!`,
    { fontSize: '32px', fill: '#ffffff', fontStyle: 'bold' }
  );
  levelUpText.setOrigin(0.5);
  
  // Make the text fade out
  scene.tweens.add({
    targets: levelUpText,
    alpha: { from: 1, to: 0 },
    duration: 1500,
    onComplete: () => {
      levelUpText.destroy();
    }
  });
}

// Calculate points for clearing lines
export function calculateLinesClearedPoints(linesCleared, level) {
  switch (linesCleared) {
    case 1:
      return GAME_CONFIG.pointsPerLine * level;
    case 2:
      return GAME_CONFIG.pointsPerLine * 2.5 * level;
    case 3:
      return GAME_CONFIG.pointsPerLine * 5 * level;
    case 4:
      return GAME_CONFIG.pointsForBlockStack * level;
    default:
      return 0;
  }
}

// Helper function to check movement - needed for scoring and game logic
function canMoveTo(board, block, offsetX, offsetY) {
  if (!block || !block.shape) return false;
  
  const shape = block.shape;
  
  for (let y = 0; y < 4; y++) {
    for (let x = 0; x < 4; x++) {
      // Only check filled blocks
      if (shape[y][x] === 1) {
        const boardX = block.x + x + offsetX;
        const boardY = block.y + y + offsetY;
        
        // Check boundaries
        if (boardX < 0 || boardX >= GAME_CONFIG.boardWidth || 
            boardY >= GAME_CONFIG.boardHeight) {
          return false;
        }
        
        // Check if the space is occupied (and not below top of board)
        if (boardY >= 0 && board[boardY][boardX] !== 0) {
          return false;
        }
      }
    }
  }
  
  return true;
}
